import axios from "axios";
import axiosInstance from "../../../Axios/Axios";

const GetAllActivePersonByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Person/GetAllActivePersonByTenantId?tenantId=${tenantId}`
  );
};

const GetAllBrothersPersonByTeamId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Person/GetAllBrothersPersonByTeamId?teamId=${tenantId}`
  );
};

const GetBrothersPersonByTeamId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Person/GetBrothersPersonByTeamId?teamId=${tenantId}`
  );
};

const GetAllActivePersonByTenantIdd = async (tenantId: any) => {
  return await axiosInstance.get(
    `/Person/GetAllActivePersonByTenantId?tenantId=${tenantId}`
  );
};

const GetAllPersonIndexByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Index/GetAllMyIndexById?tenantId=${tenantId}`
  );
};

const GetAllTenantIndexByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/Index/GetAllTenantIndexById?tenantId=${tenantId}`
  );
};


const GetAllHorizontalAlignmentByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  let periodId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetAllHorizontalAlignmentByTenantId/?tenantId=${tenantId}&definitionLevelId=${periodId}`
  );
};

const getAllObjectiveNameWithKeyResultsByTenantId = async ({
  queryKey,
}: any) => {
  let ids: any | null = queryKey[1];
  return await axiosInstance.get(
    `OKR/GetAllObjectiveNameWithKeyResultsByTenantId/?tenantId=${ids.tenantId}&definitionLevelId=${ids.definitionLevelId}&periodId=${ids.periodId}`
  );
};

const GetAllOKRStateByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/OKR/GetAllOKRStateByTenantId?tenantId=${tenantId}`
  );
};

const GetAllScoreLevelsByTenantId = async ({ queryKey }: any) => {
  let tenantId = queryKey[1];
  return await axiosInstance.get(
    `/OKR/GetAllScoreLevelsByTenantId?tenantId=${tenantId}`
  );
};

const AddKeyResult = async (krData: any) => {
  return await axiosInstance.post("OKR/AddKeyResult", krData);
};

const getAllObjectivePeriodsByTenantId = async () => {
  return await axiosInstance.get(
    "OKR/getAllPeriodsByTenantId?tenantId=3f2d72cf-cdff-413c-abcd-d5459d97890c"
  );
};

const getAllObjectiveByPeriodId = async ({ queryKey }: any) => {
  // profileTenantId
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetAllObjectiveByPeriodId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`
  );
};

const getAllCooperateOfferByTeamId = async ({ queryKey }: any) => {
  // profileTenantId
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  let keyResultId = queryKey[3];
  return await axiosInstance.get(
    `/OKR/GetAllCooperateOfferByTeamId/?teamId=${profileTenantId}&periodId=${periodId}&keyResultId=${keyResultId}`
  );
};

const getAllCooperateRequestByTeamId = async ({ queryKey }: any) => {
  // profileTenantId
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  let keyResultId = queryKey[3];
  return await axiosInstance.get(
    `/OKR/GetAllCooperateRequestByTeamId/?teamId=${profileTenantId}&periodId=${periodId}&keyResultId=${keyResultId}`
  );
};

const check = async ({ queryKey }: any) => {
  let teamId = queryKey[1];
  let keyResultId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/Check/?teamId=${teamId}&keyResultId=${keyResultId}`
  );
};

const getAllCooperate = async ({ queryKey }: any) => {
  // profileTenantId
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetAllCooperateByPeriodId/?periodId=${periodId}&tenantId=${profileTenantId}`
  );
};

const getAllCooperateByTeamId = async ({ queryKey }: any) => {
  // profileTenantId
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  let teamId = queryKey[3];
  return await axiosInstance.get(
    `/OKR/GetAllTeamCooperateByPeriodId/?periodId=${periodId}&tenantId=${profileTenantId}&teamId=${teamId}`
  );
};

const getAllObjectiveByPersonId = async ({ queryKey }: any) => {
  // profileTenantId
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/WebGetAllObjectiveByPersonId/?periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`
  );
};

const getAllObjectiveDefinitionLevelByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  return await axiosInstance.get(
    `OKR/getAllDefinitionLevelByTenantId?tenantId=${tenantId}`
  );
};

const getAllObjectiveDefinitionLevelByTenantId1 = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  let definitionLevelId: string | null = queryKey[2];
  return await axiosInstance.get(
    `OKR/GetAllHorizontalAlignmentByTenantId?tenantId=${tenantId}&definitionLevelId=${definitionLevelId}`
  );
};

const getAllObjectiveDefinitionLevelByTenantId2 = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  let definitionLevelId: string | null = queryKey[2];
  return await axiosInstance.get(
    `OKR/GetAllKeyResultsByObjectiveId?tenantId=${tenantId}&objectiveId=${definitionLevelId}`
  );
};

const GetAllObjectiveOKRStateByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  return await axiosInstance.get(
    `OKR/GetAllOKRStateByTenantId?tenantId=${tenantId}`
  );
};

const getAllTeamAndPersonNameByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  return await axiosInstance.get(
    `Team/WebGetAllTeamAndPersonNameByTenantId?tenantId=${tenantId}`
  );
};

const AddObjective = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/AddObjective`, ObjectiveData);
};

const AddObjectiveData = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/AddObjective`, ObjectiveData);
};
const EditObjective = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/EditObjective`, ObjectiveData);
};

const EditObjectiveData = async (ObjectiveData: any) => {
  return await axiosInstance.post(`OKR/EditObjective`, ObjectiveData);
};

const getObjectiveDetails = async ({ queryKey }: any) => {
  let objId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetObjectiveDetailsById/?id=${objId}`);
};

const getKeyResultDetailsById = async ({ queryKey }: any) => {
  let krId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetKeyResultDetailsById/?id=${krId}`);
};

const getObjectiveDetailsById = async ({ queryKey }: any) => {
  let obId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetObjectiveDetailsById/?id=${obId}`);
};

const editKeyResult = async (krData: any) => {
  return await axiosInstance.post("OKR/EditKeyResult", krData);
};

const transferKeyResult = async (krData: any) => {
  return await axiosInstance.post("OKR/TransferKeyResult", krData);
};


const deleteKr = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/DeleteKeyResult`, delteKrBody);
};

const deleteRequest = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/DeleteCooperateRequest`, delteKrBody);
};

const deleteoffer = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/DeleteCooperateOffer`, delteKrBody);
};

const deleteObjective = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/DeleteObjective`, delteKrBody);
};

const likeObjective = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/AddLikeObjective`, delteKrBody);
};

const disLikeObjective = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/AddDisLikeObjective`, delteKrBody);
};
const likeKr = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/AddLikeKeyResult`, delteKrBody);
};

const disLikeKr = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/AddDisLikeKeyResult`, delteKrBody);
};

const transferObjective = async (delteKrBody: any) => {
  return await axiosInstance.post(`OKR/TransferObjective`, delteKrBody);
};

const getFilterByTenantId = async ({ queryKey }: any) => {
  let tenantId: string | null = queryKey[1];
  let periodId = queryKey[2];
  return await axiosInstance.get(
    `OKR/GetFilterByTenantId?tenantId=${tenantId}&periodId=${periodId}`
  );
};

const getCooperateOfferDetailById = async ({ queryKey }: any) => {
  let obId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetCooperateOfferDetailById/?id=${obId}`);
};

const getCooperateRequestDetailById = async ({ queryKey }: any) => {
  let obId: string | null = queryKey[1];
  return await axiosInstance.get(`OKR/GetCooperateRequestDetailById/?id=${obId}`);
};

const getAllVerticalAlignmentByTenantId = async ({ queryKey }: any) => {
  let periodId = queryKey[1];
  let profileTenantId = queryKey[2];
  return await axiosInstance.get(
    `/OKR/GetAllVerticalAlignmentByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}&pageIndex=1&pageSize=50000&searchTerm=`
  );
};

const getAllObjectiveNameWithKeyResultsByTenantId1 = async ({
  queryKey,
}: any) => {
  let ids: any | null = queryKey[1];
  return await axiosInstance.get(
    `OKR/GetAllKeyResultsByObjectiveId/?tenantId=${ids.tenantId}&objectiveId=${ids.objectiveId}`
  );
};

const addCooperateRequest=async(Data:any)=>{
  return await axiosInstance.post('/OKR/AddCooperateRequest',Data)
}

const addCooperateOffer=async(Data:any)=>{
  return await axiosInstance.post('/OKR/AddCooperateOffer',Data)
}

const editCooperateRequest=async(Data:any)=>{
  return await axiosInstance.post('/OKR/EditCooperateRequest',Data)
}

const editCooperateOffer=async(Data:any)=>{
  return await axiosInstance.post('/OKR/EditCooperateOffer',Data)
}

export {
  GetAllActivePersonByTenantId,
  GetAllPersonIndexByTenantId,
  editCooperateRequest,
  editCooperateOffer,
  GetAllTenantIndexByTenantId,
  GetAllHorizontalAlignmentByTenantId,
  GetAllOKRStateByTenantId,
  GetAllScoreLevelsByTenantId,
  AddKeyResult,
  getAllObjectiveByPeriodId,
  getAllCooperateOfferByTeamId,
  getAllCooperateRequestByTeamId,
  getAllCooperate,
  getAllCooperateByTeamId,
  getAllObjectiveByPersonId,
  getAllObjectiveDefinitionLevelByTenantId,
  getAllObjectiveDefinitionLevelByTenantId1,
  getAllObjectiveDefinitionLevelByTenantId2,
  GetAllObjectiveOKRStateByTenantId,
  AddObjective,
  GetBrothersPersonByTeamId,
  GetAllBrothersPersonByTeamId,
  getObjectiveDetails,
  getKeyResultDetailsById,
  editKeyResult,
  deleteKr,
  EditObjective,
  getAllVerticalAlignmentByTenantId,
  transferObjective,
  GetAllActivePersonByTenantIdd,
  deleteObjective,
  getCooperateRequestDetailById,
  getCooperateOfferDetailById,
  getObjectiveDetailsById,
  getAllObjectiveNameWithKeyResultsByTenantId,
  getAllTeamAndPersonNameByTenantId,
  getAllObjectiveNameWithKeyResultsByTenantId1,
  getFilterByTenantId,
  AddObjectiveData,
  EditObjectiveData,
  likeObjective,
  disLikeObjective,
  transferKeyResult,
  likeKr,
  addCooperateRequest,
  addCooperateOffer,
  disLikeKr,
  deleteoffer,
  check,
  deleteRequest
};
